module.exports = __webpack_public_path__ + "img/Award_Wining_Culture.e9bfb33e.png";